import React from 'react';
import SoftBadge from 'components/common/SoftBadge';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export const informacion = {
  operation: {
    1: 'Venta',
    2: 'Alquiler',
    3: 'Temporario'
  },
  property: {
    9: 'Bodega/Galpón/Depósito',
    13: 'Bóveda/Nicho/Parcela',
    2: 'Casa',
    4: 'Cochera',
    5: 'Consultorio',
    1: 'Departamento',
    14: 'Emprendimiento',
    12: 'Edificio',
    6: 'Fondo de comercio',
    11: 'Hotel',
    7: 'Local comercial',
    8: 'Oficina comercial',
    3: 'PH',
    10: 'Terreno'
  },
  subproperty: {
    1: 'Bodega',
    2: 'Depósito',
    3: 'Galpón',
    4: 'Bóveda',
    5: 'Nicho',
    6: 'Parcela'
  },
  antiquity: {
    1: 'A estrenar',
    2: 'años de antigüedad',
    3: 'En construccion'
  },
  currency: {
    1: 'USD',
    2: 'ARS'
  }
};

const StatusBadge = ({ status }) => (
  <SoftBadge
    className="fs--3"
    bg={classNames({
      success: status === 'Activa',
      warning: status === 'Pausada',
      primary: status === 'Finalizada',
      secondary: status === 'Pendiente',
      danger: status === 'Eliminada'
    })}
  >
    <strong>{status}</strong>
  </SoftBadge>
);

StatusBadge.propTypes = {
  status: PropTypes.string
};

export const propsColumns = [
  {
    accessor: 'address',
    Header: 'Dirección',
    headerProps: { title: 'Ordenar por dirección' },
    canSort: true
  },
  {
    accessor: 'price',
    Header: 'Precio',
    headerProps: { title: 'Ordenar por precio' },
    canSort: true
  },
  {
    accessor: 'operation',
    Header: 'Operación',
    headerProps: { title: 'Ordenar por operación' },
    canSort: true
  },
  {
    accessor: 'updated_at',
    Header: 'Última modificación',
    headerProps: { title: 'Ordenar por fecha de modificación' },
    canSort: true
  },
  {
    accessor: 'type',
    Header: 'Inmueble',
    headerProps: { title: 'Ordenar por tipo de inmueble' },
    canSort: true
  },
  {
    accessor: 'status',
    Header: 'Estado',
    headerProps: { title: 'Ordenar por estado' },
    canSort: true,
    Cell: StatusBadge
  },
  {
    accessor: 'share',
    Header: 'Compartida',
    headerProps: { title: 'Ordenar por compartido' },
    Cell: ({ share }) =>
      share?.active && share?.percent ? `Si (${share.percent}%)` : 'No'
  },
  {
    accessor: 'actions',
    Header: 'Acciones',
    headerProps: { style: { cursor: 'default' }, title: null },
    canSort: false
  }
];
